import React from 'react';

/**
 * 维护模式页面组件
 * 当网站处于维护模式时显示
 */
const Maintenance: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
      color: '#fff',
      flexDirection: 'column',
      gap: '20px',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{
        fontSize: '4rem',
        marginBottom: '20px',
        animation: 'pulse 2s infinite'
      }}>🔧</div>
      
      <h1 style={{ 
        fontSize: '2.5rem', 
        color: '#d4a373',
        margin: 0,
        fontWeight: 'bold',
        letterSpacing: '0.1em'
      }}>
        NEMOLIGHT
      </h1>
      
      <p style={{ 
        fontSize: '1.2rem', 
        opacity: 0.8,
        margin: '10px 0',
        fontWeight: 300
      }}>
        网站正在维护中
      </p>
      
      <p style={{ 
        fontSize: '1rem', 
        opacity: 0.6,
        margin: '10px 0',
        maxWidth: '500px',
        lineHeight: '1.6'
      }}>
        我们正在努力修复问题，请稍后再试
      </p>
      
      <div style={{
        marginTop: '40px',
        padding: '20px 30px',
        background: 'rgba(212, 163, 115, 0.1)',
        borderRadius: '10px',
        border: '1px solid rgba(212, 163, 115, 0.3)',
        maxWidth: '400px'
      }}>
        <p style={{ margin: '5px 0', fontSize: '0.9rem', opacity: 0.9 }}>
          📅 预计恢复时间：请关注官方公告
        </p>
        <p style={{ margin: '5px 0', fontSize: '0.9rem', opacity: 0.9 }}>
          💬 如有紧急问题，请联系客服
        </p>
      </div>
      
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
};

export default Maintenance;
